module.exports = __webpack_public_path__ + "a8a10a3e/img/splash-icon.07a7c465.svg";